import { Injectable, signal } from '@angular/core'
import { IUser, UserPermissions } from '@app/core/models/user.model'

@Injectable({
    providedIn: 'root',
})
export class UserStore {
    private _userData = signal<IUser | null>(null)
    private _permissions = signal<UserPermissions | null>(null)

    readonly userData = this._userData.asReadonly()
    readonly permissions = this._permissions.asReadonly()

    setUserData(response: IUser): void {
        this._userData.set(response)
    }

    setPermissions(response: UserPermissions): void {
        this._permissions.set(response)
    }

    getUserData(): IUser | null {
        return this._userData()
    }

    getPermissions(): UserPermissions | null {
        return this._permissions()
    }

    clearUserData(): void {
        this._userData.set(null)
        this._permissions.set(null)
    }

    updateUserData(updates: Partial<IUser>): void {
        const currentUser = this._userData()
        if (currentUser) {
            this._userData.set({ ...currentUser, ...updates })
        }
    }
}
